export const can = function (value) {
  try {
    var permissions = JSON.parse(
      localStorage.getItem("jsPermissions"),
    ).permissions;
  } catch (err) {
    return false;
  }

  var _return = false;
  if (!Array.isArray(permissions)) {
    return false;
  }

  if (permissions.includes("all-permissions")) {
    return true;
  }

  if (value.includes("|")) {
    value.split("|").forEach(function (item) {
      if (permissions.includes(item.trim())) {
        _return = true;
      }
    });
  } else if (value.includes("&")) {
    _return = true;
    value.split("&").forEach(function (item) {
      if (!permissions.includes(item.trim())) {
        _return = false;
      }
    });
  } else {
    _return = permissions.includes(value.trim());
  }
  return _return;
};
